import { GspDtoMetadata } from './metadata';
import { GspDtoConvertor } from './entity/convertor/dto-convertor';
import { GspDtoSerializeContext } from './entity/serialize-context/default/gsp-dto-serialize-context';

export class GspDtoMetadataSerializer{

    serialize(metadata:GspDtoMetadata ):Object{
        let covertor:GspDtoConvertor=new GspDtoConvertor();
        let obj=new Object();
        covertor.serialize(obj,metadata,new GspDtoSerializeContext())
        return obj;
    }

    deserialize(obj:Object):GspDtoMetadata{
        let covertor:GspDtoConvertor=new GspDtoConvertor();
        let entity=new GspDtoMetadata();
        covertor.deserialize(entity,obj,new GspDtoSerializeContext());
        return entity;
    }
    
}